import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { Button, Modal, Row, Col } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";

import { style } from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";
import LocalizedStrings from "react-localization";
import AddToGroupBtn from "./AddToGroupBtn";
import RemoveFromGroupButton from "./RemoveFromGroupButton";
import { updateGroupMembers } from "./GroupManagementHelper";
import { all } from "bluebird";

let localizationStrings = new LocalizedStrings({
  en: {
    memberManageTitle: "Manage Members",
    memberEmailTitle: "Email",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "Submit",
    closeButton: "Close",
  },
  ja: {
    memberManageTitle: "メンバー管理",
    memberEmailTitle: "メールアドレス",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "送信",
    closeButton: "閉じる",
  },
  es: {
    memberManageTitle: "Gestionar Miembros",
    memberEmailTitle: "Correo Electrónico",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "Enviar",
    closeButton: "Cerrar",
  },
});

class MembersButton extends Component {
  constructor(props) {
    super(props);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.createCustomSearchField = this.createCustomSearchField.bind(this);
    this.updateSelectedMember = this.updateSelectedMember.bind(this);
    this.unselectRecipient = this.unselectRecipient.bind(this);
    this.renderAddToGroupBtn = this.renderAddToGroupBtn.bind(this);
    this.renderRemoveFromGroupBtn = this.renderRemoveFromGroupBtn.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.updateUnselectMember = this.updateUnselectMember.bind(this);

    // const cell = this.props.cellValue;
    // const row = this.props.rowValue;

    this.state = {
      // cell: cell,
      // row: row,
      allMembersArray: [], //All members from the pool.
      groupMembersArray: [], //All members in this current grp!
      selectedMembersToAdd: [],
      noDataText: "loading...",
      showPopup: false,
      loading: false,
      _notificationSystem: null,
    };
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //! OBJECT FROM PROPS TO GET EMAIL
    var membersInGroup = [];
    // console.log(this.props.members)
    if (this.props.members.members) {
      membersInGroup = Object.keys(this.props.members.members).map(
        (key) => this.props.members.members[key]
      );
      const idx = membersInGroup.findIndex(
        (eachMember) => eachMember.memberEmail === auth.currentUser.email
      );

      if (idx >= 0) {
        membersInGroup.splice(idx, 1);
      }
    } else {
      membersInGroup = [];
    }
    customLog(membersInGroup);
    customLog(this.props.members.groupId);

    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid + "/members")
      // .child(auth.currentUser.uid) // get uid from auth person object
      // .child("userGroups")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          var tempMembersArray = [];
          tempMembersArray = this.snapshotToArray(snapshot);

          const index = tempMembersArray.findIndex(
            (eachMember) => eachMember.memberEmail === auth.currentUser.email
          );
          if (index >= 0) {
            tempMembersArray.splice(index, 1);
          }

          membersInGroup.forEach((member) => {
            const idx = tempMembersArray.findIndex(
              (eachMember) => eachMember.memberEmail === member.memberEmail
            );

            if (idx >= 0) {
              tempMembersArray.splice(idx, 1);
            }
          });

          this.setState({
            allMembersArray: tempMembersArray,
            groupMembersArray: membersInGroup,
          });
        }
      });
    // var membersToSlice = membersInGroup
    // var membersToSliceFrom = tempMembersArray
    // const idx = membersToSliceFrom.findIndex(
    //   (member) => {
    //     for (var i = 0; i < membersToSlice.length; i++) {
    //       return member.memberEmail === membersToSlice[i].memberEmail
    //     }
    //   }
    // );

    // membersToSliceFrom.splice(idx);

    // console.log(membersToSliceFrom)
    // console.log(membersInGroup)
    // console.log(idx)

    // this.setState({
    //   allMembersArray: tempMembersArray,
    //   groupMembersArray: membersInGroup
    // })

    // const idx = this.state.allMembersArray.findIndex(
    //   (member) => member.memberEmail === this.state.groupMembersArray.memberEmail
    // );
    // console.log(this.state.groupMembersArray)
    // console.log(this.state.groupMembersArray.map((member) => {
    //   return member.memberEmail
    // }))
  }

  //    // console.log(snapshot.val())
  //    snapshot.forEach((eachMemberNotInGroup) => {
  //     const eachMemberNotInGroupDetails = eachMemberNotInGroup.val();
  //     const eachMemberNotInGroupEmail = eachMemberNotInGroupDetails.memberEmail;

  //     var tempMemberNotInGroupArray = []
  //     var tempMemberInGroupArray = []

  //     membersInGroup.forEach((eachMemberInGroup) => {
  //       if (eachMemberInGroup.email !== eachMemberNotInGroupEmail) {
  //         // console.log(eachMemberInGroup)
  //         console.log(eachMemberNotInGroup)
  //         tempMemberNotInGroupArray.push(eachMemberNotInGroup)
  //       } else {
  //         // console.log(eachMemberInGroup)
  //         tempMemberInGroupArray.push(eachMemberInGroup)
  //       }
  //     })
  //     // const index = membersInGroup.findIndex(
  //     //   (eachMemberInGroup) => eachMemberInGroup.email === eachMemberNotInGroupEmail
  //     // );

  //     // if (index >= 0) {
  //     //   eachMemberNotInGroupDetails.splice(index, 1);
  //     // }
  //     this.setState({
  //       allMembersArray: tempMemberNotInGroupArray,
  //       groupMembersArray: tempMemberInGroupArray,
  //     })
  //   });
  // })

  handleShow() {
    this.setState({ showPopup: true });
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  onAfterDeleteRow(rowKeys) {
    //"A111111"
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder="Search"
      />
    );
  };

  updateSelectedMember(data) {
    // console.log(data);

    const allMembersArray = this.state.allMembersArray;
    const idx = allMembersArray.findIndex(
      (member) => member.memberEmail === data[0].memberEmail
    );

    // customLog(allMembersArray)
    // console.log(data[0].memberEmail)
    // console.log(idx)

    // customLog(idx);

    if (idx >= 0) {
      allMembersArray.splice(idx, 1);
    }
    // allMembersArray.splice(idx);
    // console.log(allMembersArray);
    // console.log(this.state.groupMembersArray)

    this.setState({
      allMembersArray: allMembersArray,
      // selectedMembersToAdd: [...this.state.selectedMembersToAdd, data[0]],
      groupMembersArray: [...this.state.groupMembersArray, data[0]],
    });
    customLog("SAY HEYAYAYAYA");
  }

  unselectRecipient(data) {
    // console.log(data)

    const groupMembersArray = this.state.groupMembersArray;
    // const selectedMembersToAdd = this.state.selectedMembersToAdd;
    const idx = groupMembersArray.findIndex(
      (member) => member.memberEmail === data[0].memberEmail
    );
    // const selectedIdx = selectedMembersToAdd.findIndex((eachMember) =>
    //   eachMember.memberEmail === data[0].memberEmail
    // )

    // customLog(allMembersArray)
    // console.log(data[0].memberEmail)
    // console.log(idx)
    // console.log(selectedIdx)

    // customLog(idx);

    if (idx >= 0) {
      groupMembersArray.splice(idx, 1);
    }
    // if (selectedIdx >= 0) {
    //   selectedMembersToAdd.splice(selectedIdx, 1);
    // }
    // allMembersArray.splice(idx);
    customLog(groupMembersArray);
    // console.log(selectedMembersToAdd);

    this.setState({
      groupMembersArray: groupMembersArray,
      // selectedMembersToAdd: selectedMembersToAdd,
      allMembersArray: [...this.state.allMembersArray, data[0]],
    });

    customLog("SAY NONONONONONO");
  }

  renderAddToGroupBtn(col, row) {
    customLog("Member Management Btn Pressed");
    customLog(row);
    return (
      <AddToGroupBtn data={row} dataCallBack={this.updateSelectedMember} />
    );
  }

  renderRemoveFromGroupBtn(col, row) {
    customLog("REMOVE BTN");
    customLog(row);
    return (
      <RemoveFromGroupButton data={row} dataCallBack={this.unselectRecipient} />
    );
  }

  onSubmit() {
    // console.log("SUBMIT BUTTON CLICKED")
    // console.log(this.state.groupMembersArray)
    //! SUBMIT TO FIREBASE, NEED TO FETCH UID
    const membersToUpdate = this.state.groupMembersArray;
    const groupId = this.props.members.groupId;

    updateGroupMembers(membersToUpdate, groupId, (callback) => {
      if (callback.done) {
        this.showNotification(
          "Group Members successfully updated !",
          "success",
          "tc",
          3
        );
        this.handleClose();
      } else {
        this.showNotification(
          "Update Failed ! Bad Emails: " + callback.badEmail,
          "error",
          "tc",
          3
        );
        this.handleClose();
        customLog(callback.badEmail);
      }
    });

    //! NOTIFICATION STUFF, PUT INTO IF ELSE ASYNC AWAIT
    // this.showNotification("You group member list have been updated !", "success", "tc", 3)
    // this.handleClose()
  }

  // updateUnselectMember(data) {
  //   console.log(data)
  //   console.log(this.state.selectedMembersToAdd)
  //   const allMembersArray = this.state.allMembersArray;
  //   const selectedMembersToAdd = this.state.selectedMembersToAdd;
  //   const groupMembersArray = this.state.groupMembersArray;
  //   console.log(groupMembersArray)

  //   const selectedIdx = selectedMembersToAdd.findIndex(
  //     (eachSelect) => eachSelect.email === data
  //   );

  //   allMembersArray.push(selectedMembersToAdd[selectedIdx]);
  //   selectedMembersToAdd.splice(selectedIdx, 1);
  //   groupMembersArray.splice(selectedIdx, 1);

  //   this.setState({
  //     allMembersArray: allMembersArray,
  //     selectedMembersToAdd: selectedMembersToAdd,
  //     groupMembersArray: groupMembersArray,
  //   });

  //   customLog(selectedIdx);

  //   customLog(data);
  // }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const options = {
      // handleConfirmDeleteRow: confirmRemove,
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "5",
          value: 5,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 5, // which size per page you want to locate as default
      // pageStartIndex: 1, // where to start counting the pages
      pagination: false,
      // paginationSize: 10, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      searchField: this.createCustomSearchField,
    };

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Modal
          dialogClassName="modal-90w"
          show={this.state.showPopup}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.memberManageTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <section>
              <Row className="show-grid">
                <Col xs={6}>
                  <h3>All Members</h3>
                  <BootstrapTable
                    id="table"
                    pagination={true}
                    bordered={false}
                    data={this.state.allMembersArray}
                    // selectRow={selectRowPropForSuperAdmin}
                    options={options}
                    search
                  >
                    <TableHeaderColumn
                      dataSort
                      hidden
                      dataField="memberEmail"
                      isKey
                    />
                    <TableHeaderColumn dataSort dataField="memberEmail">
                      {localizationStrings.memberEmailTitle}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="memberEmail"
                      dataFormat={this.renderAddToGroupBtn}
                    ></TableHeaderColumn>
                  </BootstrapTable>
                </Col>
                <Col xs={1} />
                <Col xs={5}>
                  <h3>Selected members</h3>
                  <BootstrapTable
                    id="table"
                    pagination={true}
                    bordered={false}
                    options={options}
                    data={this.state.groupMembersArray}
                  >
                    <TableHeaderColumn dataSort hidden dataField="memberUid" />
                    <TableHeaderColumn dataSort dataField="memberEmail" isKey>
                      {localizationStrings.memberEmailTitle}
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="memberEmail"
                      dataFormat={this.renderRemoveFromGroupBtn}
                    ></TableHeaderColumn>
                  </BootstrapTable>
                </Col>
              </Row>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <div className={"flex"}>
              <Button
                className="submitBtn"
                // disabled={isInvalid}
                type="submit"
                onClick={this.onSubmit}
              >
                {localizationStrings.submitButton}
              </Button>
              <Button onClick={this.handleClose} className="closeBtn">
                {localizationStrings.closeButton}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <button onClick={this.handleShow} className="loginsignupbutton">
          <strong>{localizationStrings.memberManageTitle}</strong>
        </button>
      </div>
    );
  }
}

export default MembersButton;
